import { render, staticRenderFns } from "./ReceivedDocuments.vue?vue&type=template&id=0c9f4e0b"
import script from "./ReceivedDocuments.vue?vue&type=script&lang=js"
export * from "./ReceivedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports